import dynamic from "next/dynamic";
import BuildingBlocksTabsConfig from "./building-blocks-tabs-config";
import BuildingBlocksTabsAdvancedConfig from "./building-blocks-tabs-advanced-config";
const BuildingBlocksTabsComponent = dynamic(()=>import("./building-blocks-tabs-component"));
export default {
    BuildingBlocksTabsComponent,
    BuildingBlocksTabsConfig,
    BuildingBlocksTabsAdvancedConfig
};
